var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilitypole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 32c-13.25 0-24 10.75-24 23.1V64h-32V55.1C432 42.75 421.3 32 408 32S384 42.75 384 55.1V64h-96V16C288 7.163 280.8 0 272 0h-32C231.2 0 224 7.163 224 16V64H128V55.1C128 42.75 117.3 32 104 32S80 42.75 80 55.1V64h-32V55.1C48 42.75 37.25 32 24 32S0 42.75 0 55.1V96c0 17.67 14.33 32 32 32h51.16L224 221.9V512h64V221.9L428.8 128H480c17.67 0 32-14.33 32-32V55.1C512 42.75 501.3 32 488 32zM140.8 128H224v55.44L140.8 128zM288 128h83.16L288 183.4V128z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilitypole);
export default __webpack_public_path__ + "static/media/utility pole.fcac4f68.svg";
export { ForwardRef as ReactComponent };